export const lockSchedule = async (
  welletContext,
  { pax, reservationDateLocalTime, reservationType, showId, attribute },
) => {
  try {
    const result = await welletContext.apis.tickets.post('/reservation/schedule/lock', {
      pax,
      reservationDateLocalTime,
      reservationType,
      showId,
      attribute
    });
    return result.data;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      errorType: error?.response?.data?.errorType ?? null,
      message: error?.response?.data?.message ?? null,
    };
  }
};
export const lockScheduleDelete = async (
  welletContext,
  { pax, reservationDateLocalTime, reservationType, showId, token, attribute },
) => {
  try {
    const payload = {
       pax,
      reservationDateLocalTime,
      reservationType,
      showId,
      attribute,
      token
    };
    const result = await welletContext.apis.tickets.delete('/reservation/schedule/lock', {
      data: payload,
      headers: { 'Content-Type': 'application/json' },
    });
    return result.data;
  } catch (error) {
    console.error(error);

    return null;
  }
};
